import '../../../modules/legacy-scripts/vendor/lity.js';
import flexibleSectionsNavigation from './flexibleSectionsNavigation';

new flexibleSectionsNavigation(document.querySelector('[data-comp-flexible-sections]'));
